import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=506f81d1&scoped=true&"
import script from "./Size.vue?vue&type=script&lang=js&"
export * from "./Size.vue?vue&type=script&lang=js&"
import style0 from "../assets/less/filters.less?vue&type=style&index=0&id=506f81d1&lang=less&scoped=true&"
import style1 from "./Size.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f81d1",
  null
  
)

export default component.exports